import { AlertColor } from "@mui/material"

export type SnackbarState = {
    severity: AlertColor;
    message: string;
}

export const ROLE = {
    Administrator: 'administrator',
    Coarch: 'coarch',
    Parent: 'parent',
    player: 'player',
} as const;
export type Role = typeof ROLE[keyof typeof ROLE];

export type User = {
    id: string;
    token: string;
    name: string;
    email: string;
    role?: Role;
}

export type CommonState = {
    loading: number;
    drawer: boolean;
    snackbar: SnackbarState;
    user: User | null;
}

export const INITIAL_STATE: CommonState = {
    loading: 0,
    drawer: false,
    snackbar: {
        severity: 'success',
        message: ''
    },
    user: null
}
